import { render, staticRenderFns } from "./SingleAlso.vue?vue&type=template&id=7a2f876d&lang=pug&"
import script from "./SingleAlso.vue?vue&type=script&lang=js&"
export * from "./SingleAlso.vue?vue&type=script&lang=js&"
import style0 from "./SingleAlso.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports